import * as Y from 'yjs';

import { generateDefaultAnswer, DefaultAnswerConfig } from '@/widgets/utils/generateDefaultAnswer';

export const initializeAnswers = (config: DefaultAnswerConfig, answersAmount: number) => {
  const answersArray = new Y.Array();
  answersArray.push(Array.from({ length: answersAmount }).map(() => generateDefaultAnswer(config)));

  return answersArray;
};
